import React from 'react';
import lodash from 'lodash';
import { ThemeProvider } from '@material-ui/styles';
import DefaultMaterialTable from 'common/util/materialTable';
import MaterialTable from '@material-table/core';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import { optionsBuilder } from 'common/util/materialTable/options';
import { theme } from 'common/util/materialTable/themeNewDOA';
import { localization, tableIcons } from '../../../../common/util/materialTable';
import styles from './StudyUsers.scss';
import { Box } from '@material-ui/core';
import Pagination from '../../../../common/components/Pagination/Pagination';
import Toolbar from '../../../../common/components/TableToolbar/Toolbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { LoadingStatus } from '../../../../components/common/LoadingStatus/LoadingStatus';



theme.overrides.MuiTableCell.root.boxShadow = 'inset 0 -1px 0 0 var(--grey-700, #E4E4E4)';
theme.props = {
    MuiButtonBase: {
        disableRipple: true
    }
};
const rowsPerPageOptions = [10, 25, 50];
function StudyUsersTeamTable({ filterRecord, setFilterRecord, studyId, onFilterUpdate, rows, columns, pagination, setPagination, onChangePagination, dataCy, handleRowClick, isEditable,isEditAllowed, isRemoveAllowed, selectedRow, footerLabel, showFilterPills, isLoadingTable, tableName, dashboardCreateButton, highLightRow, pageSizeOption = rowsPerPageOptions, showZeroStateForFilter }) {

    const getPagination = (props) => {
        return (
            <Box>
                <Pagination {...props}
                    rowsPerPageOptions={pageSizeOption}
                    pagination={pagination}
                    setPagination={setPagination}
                    dataCy={`${dataCy}-pagination`}
                    onChangePagination={onChangePagination}
                    footerLabel={footerLabel} />
            </Box>
        );
    };

    const onChangeFilter = (filterData) => {
        onFilterUpdate(filterData);
    };

    if (!studyId) {
        const actions = [
            rowData => ({
                icon: () => <FontAwesomeIcon icon={faPencil} className={styles.editIcon} />,
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                    handleRowClick(rowData);
                },
                hidden: isEditable ? !isEditable(rowData) : isEditAllowed ? !isEditAllowed : true 
            }),
        ];
        return (
            <ThemeProvider theme={theme}>
                <Box className={styles.toolbar}>
                    <Toolbar columns={columns}
                        data={rows}
                        onChangeFilter={onChangeFilter}
                        filterRecord={filterRecord}
                        setFilterRecord={setFilterRecord}
                        showFilterPills={showFilterPills || false}
                        dataCy={`${dataCy}-toolbar`}
                        dashboardCreateButton={dashboardCreateButton} />
                </Box>
                {isLoadingTable ?
                    <LoadingStatus
                        actionLabel={'loading'}
                        itemName={tableName}
                        filterQuery={false}
                        loading
                    /> : showZeroStateForFilter ?
                        <DefaultMaterialTable
                            theme={theme}
                            columns={columns}
                            data-cy={`${dataCy}-table-zero-state`}
                            options={optionsBuilder({
                                draggable: false,
                                filtering: false,
                                search: false,
                                sorting: false,
                                pagination: false,
                                headerStyle: {
                                    fontFamily: 'Hind',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                },
                                actionsColumnIndex: -1,
                                emptyRowsWhenPaging: false
                            })}
                            components={{
                                Toolbar: (props) => null,
                                Pagination: (props) => null,
                                Body: (props) => (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={columns.length} className={styles.zeroStateFilter}>
                                                <p style={{ padding: '30px' }}>There are no {footerLabel} that match your filter/search.</p>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            }}
                        />
                        :
                        <DefaultMaterialTable
                            theme={theme}
                            data-cy={`${dataCy}-table`}
                            options={optionsBuilder({
                                pageSize: 100,
                                draggable: false,
                                filtering: false,
                                search: true,
                                sorting: false,
                                headerStyle: {
                                    fontFamily: 'Hind',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                },
                                rowStyle: (rowData) => {
                                    return {
                                        fontFamily: 'Hind',
                                        fontSize: '14px',
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        lineHeight: '22px',
                                        backgroundColor: highLightRow && rowData.taskDetailWindow.id === highLightRow ? '#F2F7FF' : '#FFF'
                                    };
                                },
                                actionsColumnIndex: -1,
                                emptyRowsWhenPaging: false
                            })}
                            columns={columns}
                            data={rows}
                            components={{
                                Toolbar: (props) => null,
                                Pagination: getPagination
                            }}
                            className={styles.userTable}
                            actions={actions}
                        />
                }
            </ThemeProvider>
        );
    }
    else {
        return (
            <ThemeProvider theme={theme}>
                <Toolbar
                    columns={columns}
                    data={rows}
                    dataCy={`${dataCy}-toolbar`} />
                <div className={styles.scrollableTableWrapper}>
                    <MaterialTable
                        icons={tableIcons}
                        localization={localization}
                        options={optionsBuilder({
                            filtering: false,
                            search: false,
                            headerStyle: {
                                fontFamily: 'Hind',
                                fontWeight: 600,
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                padding: '0px 10px 0px 0px',

                            },
                            rowStyle: { fontSize: '0.9rem' },
                            colStyle: { transition: 'all 0.3s ease' },
                            paging: lodash.get(rows, 'length') > 0,
                            paginationType: 'stepped'
                        })}
                        columns={columns}
                        data={rows}
                    />
                </div>
            </ThemeProvider>
        );
    }
}

export default StudyUsersTeamTable;